import { render, staticRenderFns } from "./ClassicalContentAdd.vue?vue&type=template&id=fe86ad50&scoped=true"
import script from "./ClassicalContentAdd.vue?vue&type=script&lang=js"
export * from "./ClassicalContentAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe86ad50",
  null
  
)

export default component.exports